import React from 'react';
export function BonusSection() {
  const bonuses = [{
    num: '1',
    title: 'Lista de compras inteligente + combos semanales',
    desc: 'Sabés exactamente qué comprar cada semana. Sin desperdiciar comida. Sin ir al supermercado a improvisar.',
    value: '$5.000 ARS'
  }, {
    num: '2',
    title: 'Postres en air fryer (sin culpa)',
    desc: 'Opciones dulces y rápidas para cuando necesitás algo rico sin arruinar todo lo que avanzaste.',
    value: '$4.000 ARS'
  }, {
    num: '3',
    title: 'Comida chatarra versión saludable',
    desc: 'Las recetas que más culpa dan, reformuladas para que las puedas disfrutar sin el peso de lo que estás haciendo.',
    value: '$4.000 ARS'
  }];
  return <section className="py-24 px-4 bg-brand-purpleDark text-white" data-id="element-37">
      <div className="max-w-4xl mx-auto" data-id="element-38">
        <div className="text-center mb-16" data-id="element-39">
          <div className="inline-flex bg-brand-yellow text-brand-purpleDark px-4 py-1.5 rounded-full font-bold text-sm mb-6 uppercase tracking-wider" data-id="element-40">
            Bonus exclusivos
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4" data-id="element-41">
            Con tu compra hoy
          </h2>
          <p className="text-brand-yellow text-xl md:text-2xl font-bold" data-id="element-42">
            ✦ recibís 3 regalos que valen más que el producto ✦
          </p>
        </div>

        <div className="space-y-6" data-id="element-43">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white/10 backdrop-blur-sm border border-white/20 p-6 md:p-8 rounded-2xl flex flex-col md:flex-row gap-6 items-start md:items-center" data-id="element-44">
              <div className="bg-brand-yellow text-brand-purpleDark w-16 h-16 rounded-2xl flex items-center justify-center font-bold text-2xl flex-shrink-0" data-id="element-45">
                #{bonus.num}
              </div>
              <div className="flex-1" data-id="element-46">
                <h3 className="text-xl md:text-2xl font-bold mb-2 text-white" data-id="element-47">
                  {bonus.title}
                </h3>
                <p className="text-gray-300 font-medium mb-4" data-id="element-48">{bonus.desc}</p>
                <div className="flex items-center gap-3 font-bold" data-id="element-49">
                  <span className="line-through text-gray-400" data-id="element-50">
                    {bonus.value}
                  </span>
                  <span className="text-brand-yellow" data-id="element-51">→ GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}